import { Box, CircularProgress, Stack } from "@mui/material"
import {
    createEmbeddingContext,
    EmbeddingContext,
    FrameOptions,
} from "amazon-quicksight-embedding-sdk"
import { ReactElement, useEffect, useRef, useState } from "react"

import { useScreenSize } from "../../hooks/useScreenSize"
import useGetQuickSightEmbeddedUrl from "../../services/middleware/hooks/insights/useGetEmbeddedQuickSightUrl"

/**
 * InsightsEmbeddedContainer component
 * TODO: Ensure page is not public
 * @returns {ReactElement} InsightsEmbeddedContainer
 */
const InsightsEmbeddedContainer = (): ReactElement => {
    const dashboardRef = useRef<HTMLDivElement>(null)
    const { isMob } = useScreenSize()
    const [embeddingContext, setEmbeddingContext] =
        useState<EmbeddingContext | null>(null)

    const { url: embeddedUrl, isLoading } = useGetQuickSightEmbeddedUrl()

    const createContext = async (): Promise<void> => {
        const context = await createEmbeddingContext()
        setEmbeddingContext(context)
    }

    const embed = async (): Promise<void> => {
        if (!dashboardRef.current || !embeddingContext) {
            return
        }

        const frameOptions: FrameOptions = {
            url: embeddedUrl ?? "",
            container: dashboardRef.current,
            height: "100%",
            width: "100%",
            resizeHeightOnSizeChangedEvent: true,
        }

        await embeddingContext.embedConsole(frameOptions)
    }

    useEffect(() => {
        createContext()
    }, [])

    useEffect(() => {
        if (embeddingContext && embeddedUrl) {
            embed()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [embeddedUrl])

    if (!embeddedUrl || isLoading) {
        return (
            <Stack
                width="100%"
                height="auto"
                justifyContent="center"
                alignItems="center"
            >
                <CircularProgress size={100} sx={{ mt: 4 }} />
            </Stack>
        )
    }

    return (
        <Box
            sx={{ mx: isMob ? 0 : -3, my: -3, pt: 0.2 }}
            height="100%"
            ref={dashboardRef}
        />
    )
}

export default InsightsEmbeddedContainer
